import MediaNavbar from "@/components/feature/MediaNavbar";
import MediaFooter from "@/components/feature/MediaFooter";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import ColumnSection from "./components/ColumnSection";
import DeepSection from "./components/DeepSection";
import AboutBand from "./components/AboutBand";
import AboutFaq from "./components/AboutFaq";
import AboutContact from "./components/AboutContact";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50">
      <MediaNavbar />
      <main>
        <Hero />
        <HotBoard />
        <ColumnSection />
        <DeepSection />
        <AboutBand />
        <AboutFaq />
        <AboutContact />
      </main>
      <MediaFooter />
      <BackToTop />
    </div>
  );
}